import { Type } from "@sinclair/typebox";
import SchemaValidator from "../schema-validator";

const createAccount = new SchemaValidator(
	Type.Object({
		id: Type.String(),
		email: Type.String(),
		enabled: Type.Boolean(),
		accountNonLocked: Type.Boolean(),
		currentUserId: Type.String(),
		userIds: Type.Array(Type.String()),
	}),
);

const login = new SchemaValidator(
	Type.Object({
		refreshToken: Type.String(),
		accountId: Type.String(),
	}),
);

const verifyEmail = new SchemaValidator(
	Type.Object({
		accountId: Type.String(),
		emailVerificationToken: Type.String(),
	}),
);

const resetPassword = new SchemaValidator(
	Type.Object({
		accountId: Type.String(),
		passwordRestToken: Type.String(),
		password: Type.String(),
	}),
);

export default {
	createAccount,
	login,
	verifyEmail,
	resetPassword,
};
